// Readers for the app-provenance <meta> tags embedded by app/main.R.
//
// The R side is the single source of truth for these (public URL from an env
// var; app/engine versions derived at runtime in app/logic/version.R), so the
// JS never hard-codes them. Mirrors the beamm-api-base pattern in lib/api.ts.

function meta(name: string): string {
  const el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  return el?.content ?? "";
}

/**
 * Public base URL a share link should point at (e.g.
 * "https://beamm.brussels/simulation"). Empty in local dev / Cypress, where we
 * fall back to the current page so a `?s=` link still round-trips.
 */
export function publicShareBase(): string {
  const configured = meta("beamm-public-url");
  if (configured) return configured;
  const { origin, pathname } = window.location;
  return `${origin}${pathname}`;
}

export function appVersion(): string {
  return meta("beamm-app-version");
}

export function engineVersion(): string {
  return meta("beamm-engine-version");
}
